import {PropertyFilter} from './property-filter';
import {NumberOperator} from './types';

export class CohortsPropertyFilter extends PropertyFilter {
  public getNumberOperators(): NumberOperator[] {
    return [
      NumberOperator.Between,
      NumberOperator.AtLeast,
      NumberOperator.GreaterThan,
      NumberOperator.LessThan,
      NumberOperator.EqualTo,
      NumberOperator.NotEqualTo,
    ];
  }
}
